// extracted by mini-css-extract-plugin
export var container = "styles-module--container--ff3d3";
export var icon = "styles-module--icon--cf0d6";
export var icons = "styles-module--icons--6a5df";
export var text = "styles-module--text--e3983";
export var twitter = "styles-module--twitter--31344";